import { HttpMethod } from '../../constants';
function replacePlanId(planId: string): string {
  return this.path.replace(':planId', planId);
}
function returnPath() {
  return this.path;
}
export const commuterPlanEndpoints = {
  [HttpMethod.Get]: {
    Plan: {
      path: '/plans/:planId',
      route: replacePlanId
    },
    Plans: {
      path: '/plans',
      route: returnPath
    },
    PlanCheckout: {
      path: '/plans/:planId/checkout',
      route: replacePlanId
    },
    IndividualBookingItemSelection: {
      path: '/plans/:planId/individual-inventory',
      route: replacePlanId
    },
    PlanInventory: {
      path: '/plans/:planId/inventory',
      route: replacePlanId
    },
    PlanAvailability: {
      path: '/plans/:planId/availability',
      route: replacePlanId
    }
  },
  [HttpMethod.Post]: {
    PlanGroups: {
      path: '/plans/:planId/groups',
      route: replacePlanId
    }
  }
};
export default commuterPlanEndpoints;